<template>
    <div class="border border-leonard-black w-full mb-3">
        <h3 class="uppercase p-3 bg-leonard-black text-leonard-white">{{title}}</h3>

        <p class="text-center pt-2">
            <span v-if="$route.params.package.split('')[0] === 'C'">Click on any individual pose below to change the pose for that composite slot.</span>
            <span v-if="$route.params.package.split('')[0] !== 'C' && items[0].qty_sheets > 1">Click on any individual sheet below to change the pose for that sheet.</span>
        </p>

        <div v-if="previouslySelected" class="text-leonard-error text-center my-3">Note: The poses below are showing from your previous selections.</div>

        <div v-for="item in items" :key="item.name" class="mx-3 my-6">
            <p><strong>{{item.name}}</strong> <small class="text-gray-500 ml-2">{{plural('image', parseInt(item.per_sheet), true)}} per sheet</small></p>

            <div class="flex flex-wrap items-top p-3" v-if="item.sheetPoses && item.sheetPoses.length > 0">
                <div class="relative m-1" v-for="n in item.qty_sheets" :key="n">
                    <div
                        class="absolute top-0 right-0 bg-gray-600 text-white opacity-75 px-2"
                        v-if="$route.params.package.split('')[0] === 'C'"
                    >
                        {{n}}
                    </div>
                    <figure class="relative">
                        <img class="border border-gray-800 cursor-pointer"
                             :src="item.sheetPoses[n-1]['path']"
                             alt="Package pose"
                             :key="n"
                             data-toggle="modal"
                             data-target="#change_pose"
                             :data-composite="n"
                             v-if="(items.length > 1 && item.sheetPoses.length > 0) || item.sheetPoses.length > 1"
                             @click="setChangable(item, n)"
                        />
                        <img class="border border-gray-800"
                             :src="item.sheetPoses[n-1]['path']"
                             alt="Package pose"
                             :key="n"
                             v-else
                        />
                        <figcaption class="absolute inset-x-0 bottom-0 text-white font-medium text-center text-shadow">
                            {{imageFNum(item.sheetPoses[n-1])}}
                        </figcaption>
                    </figure>
                </div>
            </div>

            <div v-else>
                <font-awesome-icon icon="spinner" size="2x" pulse></font-awesome-icon>
            </div>
        </div>
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSpinner } from '@fortawesome/free-solid-svg-icons';

    export default {
        props: ['title', 'items', 'previouslySelected'],

        data() {
            return {
            }
        },

        created() {
            library.add(faSpinner);
        },

        methods: {
            setChangable(item, pic_index) {
                this.$emit('setChangable', item, pic_index);
            },

            imageFNum(pose) {
                return parseInt(pose.film).toString().substr(-2) + '-' + parseInt(pose.frame).toString().padStart(3, '0');
            }
        }
    }
</script>
